import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { UploadsState, UPLOADS_SLICE_NAME } from './models';

export const uploadsSelector = (state: RootState): UploadsState => state[UPLOADS_SLICE_NAME];

export const selectUploadsIsLoading = createSelector(uploadsSelector, (state: UploadsState) => state.isLoading);
